import LocationDropdown from 'legacy/app/components/dropdowns/LocationsDropdown';
import React from 'react';
import Label from '../../../components/label/Label';
import { WhatChanged } from 'legacy/lib/api/types/WhatChangedItems';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useFeature } from 'use-feature';
import { FeatureFlags } from 'legacy/app/enums/featureFlags/featureFlags';
import cn from 'classnames';

const LocationSelect = ({
	disabled,
	handleRecalculate,
	onCreateOption,
}: {
	onCreateOption: (value: string) => void;
	disabled: boolean;
	handleRecalculate: (whatPropertyChanged: `${WhatChanged}`) => void;
}) => {
	const { id: projectId } = useParams();
	const methods = useFormContext();
	const isItemGroupsEnabled = useFeature(FeatureFlags.ItemGroups);
	return (
		<>
			<Label label="Location" />
			<Controller
				control={methods.control}
				name="loc"
				render={({ field }) => (
					<div
						className={cn('tw-w-full', {
							'tw-col-span-2': !isItemGroupsEnabled,
						})}
					>
						<LocationDropdown
							inputId="items-page-location-select"
							onCreateOption={onCreateOption}
							isCreatable
							projectId={projectId as string}
							blurInputOnSelect
							isDisabled={disabled}
							value={field.value}
							onChange={field.onChange}
							onBlur={() => {
								const selectedValue = methods.getValues('loc');
								if (selectedValue) {
									handleRecalculate(WhatChanged.LOCATION);
								}
							}}
						/>
					</div>
				)}
			/>
		</>
	);
};

LocationSelect.displayName = 'LocationSelect';

export default LocationSelect;
